"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTextLight = exports.contrastColor = exports.rgba2hex = void 0;

var rgbToYIQ = function rgbToYIQ(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  return (r * 299 + g * 587 + b * 114) / 1000;
};

var rgba2hex = function rgba2hex(rgba) {
  rgba = rgba.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return rgba && rgba.length === 4 ? "#" + ("0" + parseInt(rgba[1], 10).toString(16)).slice(-2) + ("0" + parseInt(rgba[2], 10).toString(16)).slice(-2) + ("0" + parseInt(rgba[3], 10).toString(16)).slice(-2) : "";
};

exports.rgba2hex = rgba2hex;

var hexToRgb = function hexToRgb(hex) {
  if (!hex || hex === undefined || hex === '') {
    return undefined;
  }

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : undefined;
};

var contrastColor = function contrastColor(colorHex) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;

  if (colorHex === undefined) {
    return '#000';
  }

  var rgb = hexToRgb(colorHex);

  if (rgb === undefined) {
    return '#000';
  }

  return rgbToYIQ(rgb) >= threshold ? '#000' : '#fff';
};

exports.contrastColor = contrastColor;

var isTextLight = function isTextLight(color) {
  return contrastColor(color) === '#fff';
};

exports.isTextLight = isTextLight;